/**
 * Remember that the visitor just started Cognito hosted signup, so we can
 * welcome them after they confirm their email and land back in the app.
 *
 * Hosted signup does not always complete the OIDC callback on the first
 * return (no authorize state), so the flag lives in sessionStorage until
 * the next successful sign-in in this tab.
 */

const STORAGE_KEY = 'pendingSignupConfirmation';

export function markPendingSignupConfirmation(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Private browsing or a full quota: skipping the welcome is survivable
  }
}

export function consumePendingSignupConfirmation(): boolean {
  try {
    const pending = sessionStorage.getItem(STORAGE_KEY) === '1';
    sessionStorage.removeItem(STORAGE_KEY);
    return pending;
  } catch {
    return false;
  }
}
